export const GET_TOTAL_CREDENTIALS_STATS_BEGIN =
  "GET_TOTAL_CREDENTIALS_STATS_BEGIN";

export const GET_TOTAL_CREDENTIALS_STATS_SUCCESS =
  "GET_TOTAL_CREDENTIALS_STATS_SUCCESS";

export const GET_TOTAL_CREDENTIALS_STATS_FAILURE =
  "GET_TOTAL_CREDENTIALS_STATS_FAILURE";
